<template>
  <div class="survival-plot-container">
    <div class="plot-card">
      <div class="plot-header">
        <span class="gene-title">{{ gene }}</span>
      </div>
      <div class="plot-body">
        <Plot :data="data" :layout="layout" :config="config" />
      </div>
    </div>
  </div>
</template>

<script>
import Plot from '@/components/VuePlotly/index-plotly.vue';

export default {
  name: 'SurvivalPlot',
  components: {
    Plot
  },
  props: {
    gene: {
      type: String,
      required: true
    },
    data: {
      type: Array,
      required: true
    },
    layout: {
      type: Object,
      required: true
    },
    config: {
      type: Object,
      default: () => ({})
    },
    stats: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    formatPValue(p) {
      if (p === undefined || p === null) return 'N/A';
      if (p < 0.001) return '< 0.001';
      return p.toFixed(3);
    }
  }
};
</script>

<style scoped>
.survival-plot-container {
  display: inline-block;
  margin: 4px;
}

.plot-card {
  background: white;
  border-radius: 6px;
  border: 1px solid #ddd;
  overflow: hidden;
}

.plot-header {
  padding: 8px 12px;
  background: #f5f5f5;
  border-bottom: 1px solid #ddd;
}

.gene-title {
  font-size: 14px;
  font-weight: 600;
  color: #333;
}

.plot-body {
  padding: 8px;
  background: white;
}
</style>

